export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    if (error.message.indexOf('PIECE_JOINTE_FORBIDDEN_TO_DELETE') === 0) {
      messages.push({
        message: 'piecesJointes.messages.deleteError',
      });
    }
  });
}
